// Lead source options for consistent use across the application
// These values match the schema validation in convex/schema.ts

export const LEAD_SOURCES = [
  { value: "lead_scout", label: "Lead Scout" },
  { value: "ai_lead_scout", label: "Lead Scout" },
  { value: "website", label: "Website" },
  { value: "referral", label: "Referral" },
  { value: "cold-call", label: "Cold Call" },
  { value: "cold-email", label: "Cold Email" },
  { value: "trade-show", label: "Trade Show" },
  { value: "conference", label: "Conference" },
  { value: "social-media", label: "Social Media" },
  { value: "linkedin", label: "LinkedIn" },
  { value: "google-ads", label: "Google Ads" },
  { value: "facebook-ads", label: "Facebook Ads" },
  { value: "seo", label: "SEO / Organic Search" },
  { value: "direct-mail", label: "Direct Mail" },
  { value: "door-to-door", label: "Door to Door" },
  { value: "networking-event", label: "Networking Event" },
  { value: "industry-association", label: "Industry Association" },
  { value: "existing-client", label: "Existing Client" },
  { value: "partner-referral", label: "Partner Referral" },
  { value: "other", label: "Other" },
] as const;

export type LeadSourceValue = (typeof LEAD_SOURCES)[number]["value"];

/**
 * Formats a lead source value to its display label
 * @param source - The source value (e.g., "cold-call")
 * @returns The formatted label (e.g., "Cold Call") or "N/A" if not found
 */
export function formatLeadSource(source: string | undefined): string {
  if (!source) return "N/A";
  const found = LEAD_SOURCES.find((s) => s.value === source);
  return found ? found.label : source;
}
